import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Form } from "react-bootstrap";
import Swal from 'sweetalert2';
import api from "../api/axios";

export default function SystemSetting() {
    const [search, setSearch] = useState("");
    const [filteredSettings, setFilteredSettings] = useState([]);
    const [settings, setSettings] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [updatingId, setUpdatingId] = useState(null);

    const normalizeText = (text) => {
        return text
        ?.toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    };

    // ==============================
  // Filtro de búsqueda
  // ==============================
    useEffect(() => {
        const result = settings.filter(
        (s) =>
            normalizeText(s.name)?.includes(normalizeText(search))
        );
        setFilteredSettings(result);
    }, [search, settings]);

    // ==============================
    // Fetch inicial
    // ==============================
    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            setLoadingTable(true);
            const res = await api.get("/systemSettings");
            setFilteredSettings(res.data.data);
            setSettings(res.data.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingTable(false);
        }
    }
   
    // ==============================
    // Editar estado
    // ==============================
    const toggleSetting = async (row) => {
        const newValue = row.value === '1' ? '0' : '1';

        setUpdatingId(row.id);

        try {
            await api.put(`/systemSettings/${row.id}`, {
                ...row,
                value: newValue
            });

            // Actualizar tabla sin volver a pedir todo
            setSettings((prev) =>
                prev.map((s) =>
                    s.id === row.id ? { ...s, value: newValue } : s
                )
            );

            setFilteredSettings((prev) =>
                prev.map((s) =>
                    s.id === row.id ? { ...s, value: newValue } : s
                )
            );

        } catch (err) {
            Swal.fire({
            title: 'Error',
            text: 'No se pudo actualizar el estado',
            icon: 'error',
            timer: 1500,
            showConfirmButton: false
            });
        } finally {
            setUpdatingId(null);
        }
    };

    const getDisplayName = (name) => {
        if (!name) return "";

        return name.toLowerCase() === "emergency"
            ? "Botón Emergencia"
            : name;
    };
   
    // ==============================
    // Columnas tabla
    // ==============================
    const columns = [
        {
            name: "Nombre",
            selector: (row) => getDisplayName(row.name),
            sortable: true
        },
        {
            name: "Estado",
            cell: (row) => (
                <div className="d-flex align-items-center gap-2">
                {updatingId === row.id ? (
                    <span className="spinner-border spinner-border-sm text-primary"></span>
                ) : (
                    <Form.Check
                    type="switch"
                    checked={row.value === '1'}
                    onChange={() => toggleSetting(row)}
                    />
                )}
                </div>
            ),
            sortable: true,
        },
    ];

    return (
        <div className="mt-4">
            {/* TABLA */}
            <DataTable
                title="Variables de Configuración"
                columns={columns}
                data={filteredSettings}
                pagination
                highlightOnHover
                striped
                progressPending={loadingTable}
                progressComponent={
                    <div className="text-center p-3">
                        <div className="spinner-border text-primary"></div>
                        <p>Cargando...</p>
                    </div>
                }
                subHeader
                subHeaderComponent={
                <div className="d-flex justify-content-between w-100">
                    <input
                    type="text"
                    className="form-control w-25"
                    placeholder="Buscar..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                }
            />
        </div>
    );
}